import React from 'react';
import { Check, PauseCircle } from 'lucide-react';
import { PROJECT_STATUS_ORDER, projectStatus, projectStatusLabel } from '../lib/workStatus';

export const ProjectStatusStepper = ({ status, history = [], t, showHistory = true }) => {
  const currentIndex = PROJECT_STATUS_ORDER.indexOf(status === 'active' ? 'in_progress' : status);
  const onHold = status === 'on_hold';
  const recent = [...(history || [])].reverse().slice(0, 5);

  return (
    <div data-testid="project-status-stepper">
      <div className="flex items-center justify-between text-xs text-[#2E2E2E]/60 mb-3">
        <span className="font-medium">Objekta gaita</span>
        {onHold && (
          <span className="flex items-center gap-1 text-orange-700 font-semibold" data-testid="project-status-on-hold">
            <PauseCircle className="w-4 h-4" /> {projectStatusLabel(t, 'on_hold')}
          </span>
        )}
      </div>
      <ol className="flex items-start w-full">
        {PROJECT_STATUS_ORDER.map((step, index) => {
          const done = !onHold && index < currentIndex;
          const current = !onHold && index === currentIndex;
          const config = projectStatus(step);
          return (
            <li key={step} className="flex-1 flex flex-col items-center relative" data-testid={`project-status-step-${step}`} data-state={current ? 'current' : done ? 'done' : 'pending'}>
              {index > 0 && (
                <span className={`absolute top-3.5 right-1/2 w-full h-0.5 -translate-y-1/2 ${done || current ? 'bg-[#1F3D2B]' : 'bg-gray-200'}`} />
              )}
              <span
                className={`relative z-10 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-all duration-300 ${
                  done ? 'bg-[#1F3D2B] border-[#1F3D2B] text-white' : current ? 'bg-white border-[#1F3D2B] text-[#1F3D2B] ring-4 ring-[#1F3D2B]/15 scale-110' : 'bg-white border-gray-300 text-gray-400'
                }`}
              >
                {done ? <Check className="w-4 h-4" /> : index + 1}
              </span>
              <span className={`mt-2 text-[11px] sm:text-xs text-center leading-tight px-1 ${current ? 'font-semibold text-[#1F3D2B]' : done ? 'text-[#2E2E2E]/70' : 'text-[#2E2E2E]/40'}`}>
                {projectStatusLabel(t, step)}
              </span>
              {current && <span className="sr-only">{config.label}</span>}
            </li>
          );
        })}
      </ol>
      {showHistory && recent.length > 0 && (
        <div className="mt-5 border-t border-gray-100 pt-3" data-testid="project-status-history">
          <p className="text-xs font-medium text-[#2E2E2E]/60 mb-2">Statusu vēsture</p>
          <ul className="space-y-1.5">
            {recent.map((entry, index) => (
              <li key={`${entry.date}-${index}`} className="flex flex-wrap items-baseline gap-x-2 text-xs text-[#2E2E2E]/80" data-testid={`project-status-history-${index}`}>
                <span className="text-[#2E2E2E]/50 tabular-nums">{new Date(entry.date).toLocaleDateString('lv-LV')}</span>
                <span className={`px-2 py-0.5 rounded-full font-medium ${projectStatus(entry.status).className}`}>{projectStatusLabel(t, entry.status)}</span>
                {entry.comment && <span className="italic">— {entry.comment}</span>}
                {entry.user && <span className="text-[#2E2E2E]/50">({entry.user})</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ProjectStatusStepper;
